import classNames from 'classnames/bind';
import React, { useContext, useEffect } from 'react';
import { DEFAULT_ERROR_MESSAGE } from '../../Base.constants';
import { SessionContext } from '../../context/SessionContext';
import { ToastContext } from '../../context/ToastContext';
import ChatIntro from '../ChatIntro';
import ChatMessages from '../ChatMessages';
import Terms from '../Terms';
import styles from './ChatBody.module.scss';

const cx = classNames.bind(styles);

export default function ChatBody(): React.ReactElement {
  const { acceptedTerms, isLoading, isError } = useContext(SessionContext);
  const toast = useContext(ToastContext);

  useEffect(() => {
    if (isError) {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  }, [isError]);

  return (
    <div className={cx('body')}>
      <ChatIntro />
      <hr />
      {acceptedTerms || isLoading ? <ChatMessages /> : <Terms />}
    </div>
  );
}
